import { Button } from 'components/elements/Button'
import React from 'react'
import { BannerStateType } from './BannerDetails'
import { isDarkBannerColor } from './bannerColors'

type PreviewBannerProps = {
  state: BannerStateType,
  cta: boolean,
}

const PreviewBanner = ({state, cta}: PreviewBannerProps) => {

  const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  const bannerColor = state.bannerColor || '#FFFFFF'
  const isDark = isDarkBannerColor(bannerColor)
  const numberCn = `w-10 h-10 border rounded my-1 flex items-center justify-center ${isDark ? 'border-white text-white' : 'border-black text-black'}`

  return (
    <div className={`mx-20 text-sm font-normal p-5
        ${isDark ? 'text-white' : 'text-deepgray'}
        ${state.type === 'text'
          ? 'flex justify-center items-center text-center h-16'
          : 'text-center overflow-auto h-32'}`}
        style={{backgroundColor: bannerColor}}
      >
        <div className="inline-block">
          <div className={`${state.type === 'text'
            ? 'flex items-center justify-center'
            : 'text-start'}`}
          >
            {state.bannerText || 'Live banner preview'}
            <div className="flex justify-center items-center">
              {((state.type === 'range5' && cta)) && <div className="flex">
                {nums.slice(1, 6).map((num) => {
                  if (num === 1) {
                    return (
                      <div key={num} className="flex flex-col w-10 items-center justify-center">
                          <div
                            style={{backgroundColor: bannerColor}}
                            className={`${numberCn} mr-1`}
                          >
                            {num}
                          </div>
                          <div className="whitespace-nowrap">{state.minRangeCopy || 'e.g. “Least likely”'}</div>
                      </div>
                    )
                  }
                  if (num === 5) {
                    return (
                      <div key={num + 11} className="flex flex-col w-10 items-center justify-center">
                          <div
                            style={{backgroundColor: bannerColor}}
                            className={numberCn}
                          >
                            {num}
                          </div>
                          <div className="whitespace-nowrap">{state.maxRangeCopy || 'e.g. “Most likely”'}</div>
                      </div>
                    )
                  }
                  return (
                    <div
                      key={num + 22}
                      style={{backgroundColor: bannerColor}}
                      className={`${numberCn} mr-1`}
                    >
                      {num}
                    </div>
                  )

                })}
              </div>}
              {((state.type === 'range10' && cta)) && <div className="flex">
                {nums.slice(0, nums.length + 1).map((num) => {
                  if (num === 0) {
                    return (
                      <div key={num + 33} className="flex flex-col w-10 items-center justify-center">
                          <div
                            style={{backgroundColor: bannerColor}}
                            className={`${numberCn} mr-1`}
                          >
                            {num}
                          </div>
                          <div className="whitespace-nowrap">{state.minRangeCopy || 'e.g. “Least likely”'}</div>
                      </div>
                    )
                  }
                  if (num === 10) {
                    return (
                      <div key={num + 44} className="flex flex-col w-10 items-center justify-center">
                          <div
                            style={{backgroundColor: bannerColor}}
                            className={numberCn}
                          >
                            {num}
                          </div>
                          <div className="whitespace-nowrap">{state.maxRangeCopy || 'e.g. “Most likely”'}</div>
                      </div>
                    )
                  }
                  return (
                    <div
                      style={{backgroundColor: bannerColor}}
                      className={`${numberCn} mr-1`}
                      key={num + 55}
                    >
                      {num}
                    </div>
                  )
                })}
              </div>}
              {cta && <Button
                type={isDark ? 'light' : undefined}
                className={`${(state.type === 'range5' || state.type === 'range10') && 'mb-5'} ml-4`}
                text={(state.ctaButton && state.ctaButton.label) || 'CTA Button'}
                onClick={e => e.preventDefault()} />
                }
            </div>
          </div>
        </div>
      </div>
  )
}

export default PreviewBanner
